export { default as Logo } from '@/assets/images/logo.png';

import TimeoutAR from '@/assets/images/ar/timeout.gif';
import CorrectAR from '@/assets/images/ar/correct.gif';
import WrongAR from '@/assets/images/ar/wrong.gif';
import IntroAR from '@/assets/images/ar/intro.gif';
import LogoAR from '@/assets/images/ar/logo.jpg';

import TimeoutEN from '@/assets/images/en/timeout.gif';
import CorrectEN from '@/assets/images/en/correct.gif';
import WrongEN from '@/assets/images/en/wrong.gif';
import IntroEN from '@/assets/images/en/intro.gif';
import LogoEN from '@/assets/images/en/logo.jpg';

export default {
  Timeout: { ar: TimeoutAR, en: TimeoutEN },
  Correct: { ar: CorrectAR, en: CorrectEN },
  Wrong: { ar: WrongAR, en: WrongEN },
  Intro: { ar: IntroAR, en: IntroEN },
  Logo: { ar: LogoAR, en: LogoEN }
};

